/* eslint-disable */
const iBookmarker = {
    el: $('.I-js-search-bookmarker'),

    init: function () {
        this.bindEvents();

        var item = JSON.parse(localStorage.getItem('bookmark'));
        if (item !== null ) {
            this.bookmark(item.id);
            localStorage.removeItem('bookmark');
        }
    },

    bindEvents: function () {
        this.el.on('click', function (event) {
            event.preventDefault();
            var id = $(this).data('id');
            //Fokus-Styles entfernen, nachdem der Button geklickt wurde.
            $(this).trigger('blur');
            localStorage.setItem('bookmark', JSON.stringify({'id': id}));
            iBookmarker.bookmark(id);
        });
    },

    bookmark: function (id) {
        $.ajax({
            method: "POST",
            url: iBookmarkerBookmarkUrl,
            data: { expose_id: id }
        }).done(function( msg ) {
            var items = $('.I-js-search-bookmarker[data-id=' + id + ']');

            //msg sollte ein Array mit allen gemerkten Expose-Ids enthalten.
            //Wenn das Expose gebookmarkt/enfternt wurde Icon anpassen.
            if (msg.indexOf(String(id)) !== -1) {
                items.each(function () {
                    $(this).addClass('bookmarked');
                });
            } else {
                items.each(function () {
                    $(this).removeClass('bookmarked');
                });
            }

            localStorage.removeItem('bookmark');
        }).fail(function( jqXHR ) {
            //Wenn der Nutzer nicht eingeloggt ist, dann auf die Login-Seite weiterleiten.
            if (jqXHR.status === 403) {
                window.document.location.href = iBookmarkerLoginUrl;
            }
        });
    }
};

export default iBookmarker;
